module.exports = __webpack_public_path__ + "static/media/loxam-logo-white-default.be0e2829.svg";